import { usePostPortfolioBankProductMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioBankProductMutation";
import { usePostPortfolioBuildingSavingsMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioBuildingSavingsMutation";
import { usePostPortfolioInvestmentMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioInvestmentMutation";
import { usePostPortfolioPensionProductsMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioPensionProductsMutation";
import type { NewContractFormOutput } from "web_myplann/Goals/Forms/newContractFormSchema";
import { mapNewContractToCreateRequest } from "web_myplann/Goals/Mappers/mapNewContractToCreateRequest";
import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";

export const useCreateGoalContract = () => {
	const { mutateAsync: createBankProduct, isPending: isCreatingBankProduct } =
		usePostPortfolioBankProductMutation();
	const {
		mutateAsync: createBuildingSavings,
		isPending: isCreatingBuildingSavings,
	} = usePostPortfolioBuildingSavingsMutation();
	const { mutateAsync: createInvestment, isPending: isCreatingInvestment } =
		usePostPortfolioInvestmentMutation();
	const { mutateAsync: createPension, isPending: isCreatingPension } =
		usePostPortfolioPensionProductsMutation();

	const createByType = (values: NewContractFormOutput) => {
		const request = mapNewContractToCreateRequest(values);

		switch (values.type) {
			case ClientPortfolioDomainEnum.BuildingSavings:
				return createBuildingSavings(request);
			case ClientPortfolioDomainEnum.Investments:
				return createInvestment(request);
			case ClientPortfolioDomainEnum.PensionProducts:
				return createPension(request);
			default:
				return createBankProduct(request);
		}
	};

	const createContract = async (values: NewContractFormOutput) => {
		const { id } = await createByType(values);

		return id;
	};

	return {
		createContract,
		isPending:
			isCreatingBankProduct ||
			isCreatingBuildingSavings ||
			isCreatingInvestment ||
			isCreatingPension,
	};
};
